import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/fichiers-dossier`;
const token = localStorage.getItem("token");

/// GET - Tous les fichiers
export const getAllFichiers = async () => {
  try {
    const response = await axios.get(`${apiUrl}/getAll`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des fichiers:", error);
  }
};

/// GET - Fichiers d’un segment
export const getFichiersBySegmentId = async (segmentId) => {
  try {
    const response = await axios.get(`${apiUrl}/getBySegment/${segmentId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des fichiers par segment:", error);
  }
};

/// GET - Fichier par ID
export const getFichierById = async (fichierId) => {
  try {
    const response = await axios.get(`${apiUrl}/getById/${fichierId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement du fichier:", error);
  }
};

/// POST - Ajouter un fichier
export const addFichier = async (data) => {
  try {
    const response = await axios.post(`${apiUrl}/add`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout du fichier:", error);
  }
};

/// PUT - Modifier un fichier
export const updateFichier = async (fichierId, data) => {
  try {
    const response = await axios.put(`${apiUrl}/edit/${fichierId}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du fichier:", error);
  }
};

/// DELETE - Supprimer un fichier
export const deleteFichier = async (fichierId) => {
  try {
    const response = await axios.delete(`${apiUrl}/delete/${fichierId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du fichier:", error);
  }
};
